
export const sortByNameInAlphabeticalOrder = (arr, prop = 'name') => {

    // Function allows to sort objects in array in alphabetical order by any property
    // if its name passed as the second param. Default is sorting by "name" prop

    if(typeof prop !== 'string') {
        return arr;
    }

    if(!Array.isArray(arr)) {
        return arr;
    } else {
        const checkValuesToBeComparable = (...values) => {
            return values.reduce((res, v) => {
                if(!res) {
                    return res;
                }
                return !!(typeof v === 'object' && v !== null && Object.prototype.hasOwnProperty.call(v, prop));
            }, true);
        };
        return arr.sort((a, b) => checkValuesToBeComparable(a, b) ? a[prop].localeCompare(b[prop]) : 0);
    }
};